import { NextDisplayView } from '../../login-authentication-screen/models/login-credentials.interface';

export interface recoverAccountView {
  headerSubTitle: string;
  headerTitle: string;
  wifiPortal: boolean;
  message: {
    modal: string;
    wfp: string;
    emailExpired: string;
  };
  nextDisplayView: NextDisplayView;
  logoUrl: string;
  altText: string;
}
